import type { CSSProperties } from 'react';

// Visually hidden but kept in the accessibility tree (never `display:none`,
// which screen readers skip). Escape hatch for a11y only — not a layout style.
const SR_ONLY: CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};

/**
 * Always-present, text-free polite live region for the chat surface. Each
 * assistant bubble carries its own `aria-live` (so a new reply is announced
 * without duplicating its text on the page), but an empty thread has no bubble
 * yet — this keeps a polite live region attached from first paint. It holds no
 * text, so it never shadows the visible transcript for text-based queries.
 */
export function ChatLiveRegion() {
  return <div aria-live="polite" style={SR_ONLY} />;
}
